import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

const NONE = "__none__";

/** "Paid from" / "Received in" picker. Lists the active bank accounts of the chosen company.
 *  value is the bank id or "" (= general Cash & Bank ledger). Renders nothing until the company has accounts. */
export default function BankAccountSelect({ companyId, value, onChange, label = "Paid from", testId = "bank-account-select" }) {
  const [banks, setBanks] = useState([]);

  useEffect(() => {
    if (!companyId) { setBanks([]); return; }
    let live = true;
    api.get("/masters/bank-accounts", { params: { company_id: companyId, active_only: true } })
      .then(({ data }) => { if (live) setBanks(data || []); })
      .catch(() => { if (live) setBanks([]); });
    return () => { live = false; };
  }, [companyId]);

  useEffect(() => {
    if (value && banks.length && !banks.some((b) => b.id === value)) onChange("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [banks]);

  if (!banks.length) return null;
  return (
    <div>
      <Label>{label}</Label>
      <Select value={value || NONE} onValueChange={(v) => onChange(v === NONE ? "" : v)}>
        <SelectTrigger data-testid={testId} className="mt-1.5"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value={NONE}>General Cash &amp; Bank (not specified)</SelectItem>
          {banks.map((b) => <SelectItem key={b.id} value={b.id}>{b.name}{b.bank_name && b.bank_name !== b.name ? ` · ${b.bank_name}` : ""}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
